import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
} from 'mobx-state-tree';
import { request } from 'lib';
import { getGlobalStore } from 'stores';
import UserModel, { extendUserModel } from 'models/user-model';
import SimpleUserModel from 'models/simple-user-model';
import { getStore } from './index';

const initState = {
  userMap: {},
  roomViewers: {},
  newUserList: [],
};

// 在线观众的
const RoomViewerModel = types
  .model('RoomViewerModel', {
    users: types.array(UserModel),
    user_count: 0,
    vips: types.array(UserModel),
    vip_count: 0,
  })
  .views((self) => {
    return {
      // 总数
      get totalCount() {
        return self.user_count + self.vip_count;
      },
    };
  });

const NewUserModel = extendUserModel('NewUserModel', {
  last_login_platform: '',
  new_user_level: 0,
  task_done: 0,
  task_total: 0,
  score: 0,
  hiding: false,
});

const Model = types
  .model('UsersModel', {
    userMap: types.map(UserModel),
    // 在线观众的
    roomViewer: types.optional(RoomViewerModel, {}),
    // 新用户列表
    newUserList: types.array(NewUserModel),
    currentTab: 'online',
    multiRoomUserList: types.array(UserModel),
  })
  .actions((self) => {
    const add = (user) => {
      self.userMap.put(user);
    };

    const loadRoomViewer = flow(function* () {
      const {
        room: { roomId },
      } = getStore();
      let res;
      try {
        res = yield request.cryolite.get(
          `api/v1/room/viewers/${roomId}`,
          // `https://cryolite.memeyule.com/api/v1/room/viewers/${107531578}`,
        );

        self.roomViewer = res.data;
      } catch (e) {
        console.error('loadRoomViewer', e);
      }
    });
    const loadNewUserList = flow(function* () {
      const {
        room: { roomId, isRoomOwner },
      } = getStore();
      let res;
      if (!getGlobalStore().isLogin || !isRoomOwner) {
        return;
      }

      try {
        res = yield request.cryolite.get(`api/v2/newuser/room_viewer`, {
          token: true,
        });

        self.newUserList = res.data.items.map((item) => {
          item.pay_level_info = {
            level: item.pay_level,
          };
          return item;
        });
      } catch (e) {
        console.error('loadNewUserList', e);
      }
      //
    });

    // const init = () => {
    //   loadRoomViewer();
    //   // loadNewUserList();
    // };

    const setTab = (tab) => {
      self.currentTab = tab;
    };

    const updateMultiRoomUserList = (list) => {
      self.multiRoomUserList = list;
    };
    return {
      add,
      loadNewUserList,
      loadRoomViewer,
      updateMultiRoomUserList,
      setTab,
    };
  });

export default {
  initState,
  Model,
};
